import React from 'react';
import { SignupLayout, SignupPlanView } from '../components';
import { useSignupPlanViewController } from '../controllers';

const SignupPlanPage: React.FC = () => {
  const {
    plans,
    localNumberPriceUsd,
    loading,
    error,
    notice,
    inProgress,
    startingPlanId,
    unavailable,
    choosePlan,
    continueSignup,
    retry,
  } = useSignupPlanViewController();

  return (
    <SignupLayout>
      <SignupPlanView
        plans={plans}
        localNumberPriceUsd={localNumberPriceUsd}
        loading={loading}
        error={error}
        notice={notice}
        inProgress={inProgress}
        startingPlanId={startingPlanId}
        unavailable={unavailable}
        onChoosePlan={choosePlan}
        onContinue={continueSignup}
        onRetry={retry}
      />
    </SignupLayout>
  );
};

export default SignupPlanPage;
